
IB.is_in_mice =  document.querySelector('.mice-header') !== null;